export default __webpack_public_path__ + "static/media/electric.29f06f23.svg";